import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { cn } from '../utils/cn';
const sizeClasses = {
    xs: 'h-6 w-6 text-xs',
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-16 w-16 text-lg',
    '2xl': 'h-20 w-20 text-xl',
};
/**
 * Generate initials from a name string.
 * Returns up to 2 characters.
 */
function getInitials(name) {
    if (!name)
        return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
/**
 * Generate a consistent background color based on the name.
 */
function getColorClass(name) {
    const colors = [
        'bg-primary-500',
        'bg-secondary-500',
        'bg-success-500',
        'bg-info-500',
        'bg-warning-500',
        'bg-danger-500',
        'bg-primary-600',
        'bg-info-600',
    ];
    if (!name)
        return colors[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
}
export const Avatar = forwardRef(({ src, alt, name, size = 'md', className, ...props }, ref) => {
    const [imgError, setImgError] = useState(false);
    const showImage = src && !imgError;
    const initials = getInitials(name);
    return (_jsx("div", { ref: ref, className: cn('relative inline-flex items-center justify-center rounded-full overflow-hidden shrink-0', !showImage && getColorClass(name), sizeClasses[size], className), role: "img", "aria-label": alt || name || 'Avatar', ...props, children: showImage ? (_jsx("img", { src: src, alt: alt || name || 'Avatar', className: "h-full w-full object-cover", onError: () => setImgError(true) })) : (_jsx("span", { className: "font-medium text-white select-none", children: initials })) }));
});
Avatar.displayName = 'Avatar';
//# sourceMappingURL=Avatar.js.map